<template lang="pug">
    v-dialog(v-model="localValue" persistent max-width="500")
      v-card(style="border-radius: 10px")
        v-card-title(class="text-h5 pt-8 px-8")
          div(class="text-center")
            img(src="../assets/warning1.png")
            h3(class="title-alert py-2") Document Belum Lengkap
            p(class="word-wrap info1") 
              | Masih terdapat dokumen pada 
              span(style="color: #ED1B24; text-decoration: none;")
                | Daftar Periksa
              span(class="highlighted-text")
              |  yang belum diunggah. Harap unggah seluruh dokumen yang dipersyaratkan sebelum melanjutkan.
            p(class="word-wrap info2 px-15") 
              | Untuk informasi lebih lengkap silahkan hubungi Departmen STC PT BIB. 
              a(:href="whatsappUrl" target="_blank" style="color: #ED1B24; text-decoration: none;") Disini
  
        v-card-actions(class="justify-center")
          v-btn(class="mb-8 text-none px-15" dark color="#ED1B24" @click="closeDialog") Kembali
  
</template>

<script>
export default {
    name: "AlertDialogDocumentUpload",
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        },
        whatsappUrl() {
            const message = `Hallo, saya tidak dapat melakukan pengajuan kelistrikan, apakah bisa dibantu?%0A%0A`;
            const waNumber = process.env.VUE_APP_WA_NUMBER; // Get the WhatsApp number from the environment variable
            return `https://wa.me/${waNumber}?text=${encodeURIComponent(message)}`;
        }
    },
    methods: {
        closeDialog() {
            this.$emit("input", false);
        }
    }
};
</script>

<style scoped>
.red-text {
    color: #EA5164;
}
</style>